// @flow

//
// React
//
import React, { type Node } from 'react';

//
// Trix Middleware
//
import { get as httpGet } from '../../../../lib/trix-web-middleware-commons';

//
// Trix Data
//
import {
    hasErrorCausesForLocation,
    formatErrorsForLocation,
} from '../../../../lib/trix-web-data-commons';

//
// Formatter
//
import {
    fmtPercent,
    fmtMoney, 
} from '../../../../lib/trix-web-data-commons';

//
// Props
//
type Props = {
    name: string,
    label: string,
    description: string,
    helperText: string,
    disabled: boolean;

    value: any,
    error: any,

    data: any,

    onChange: (data: any) => void,
}

//
// Component
//
const PaymentAccountBalanceFormPaneField = (props: Props): Node => {
    //
    // Hooks
    //
    // End hooks

    return (
        <div>
            {Object.values(props.data || {}).map(a => {
                return (<div>{fmtMoney(a)}</div>);
            })}
        </div>
    );
};
export default PaymentAccountBalanceFormPaneField;
